import { render, staticRenderFns } from "./candidate.vue?vue&type=template&id=d662aa7e&scoped=true"
import script from "./candidate.vue?vue&type=script&lang=js"
export * from "./candidate.vue?vue&type=script&lang=js"
import style0 from "./candidate.vue?vue&type=style&index=0&id=d662aa7e&prod&lang=scss&scoped=true"
import style1 from "./candidate.vue?vue&type=style&index=1&id=d662aa7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d662aa7e",
  null
  
)

export default component.exports